import { render, staticRenderFns } from "./NavbarItem.vue?vue&type=template&id=74e66c0a"
import script from "./NavbarItem.vue?vue&type=script&lang=ts"
export * from "./NavbarItem.vue?vue&type=script&lang=ts"
import style0 from "./NavbarItem.vue?vue&type=style&index=0&id=74e66c0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports